var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "478.454 127.902 194.033 195.386",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-0",
    gradientUnits: "userSpaceOnUse",
    x1: 108,
    y1: 1.495,
    x2: 108,
    y2: 42.5,
    xlinkHref: "#gradient-88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0, 235, 170)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(94, 103, 223)"
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-1",
    gradientUnits: "userSpaceOnUse",
    x1: 82.5,
    y1: 19.5,
    x2: 82.5,
    y2: 49.5,
    xlinkHref: "#gradient-88"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-2",
    gradientUnits: "userSpaceOnUse",
    x1: 135.5,
    y1: 17.441,
    x2: 135.5,
    y2: 47.5,
    xlinkHref: "#gradient-88"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-3",
    gradientUnits: "userSpaceOnUse",
    x1: 139.529,
    y1: 21.438,
    x2: 139.529,
    y2: 90.5,
    xlinkHref: "#gradient-88"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-4",
    gradientUnits: "userSpaceOnUse",
    x1: 79.978,
    y1: 22.468,
    x2: 79.978,
    y2: 65.5,
    xlinkHref: "#gradient-88"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-5",
    gradientUnits: "userSpaceOnUse",
    x1: 77.006,
    y1: 39.5,
    x2: 77.006,
    y2: 121.078,
    xlinkHref: "#gradient-88"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-6",
    gradientUnits: "userSpaceOnUse",
    x1: 66.887,
    y1: 38.5,
    x2: 66.887,
    y2: 103.5,
    xlinkHref: "#gradient-88"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-7",
    gradientUnits: "userSpaceOnUse",
    x1: 116.523,
    y1: 60.395,
    x2: 116.523,
    y2: 66.5,
    xlinkHref: "#gradient-88"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-8",
    gradientUnits: "userSpaceOnUse",
    x1: 82.004,
    y1: 71.5,
    x2: 82.004,
    y2: 95.571,
    xlinkHref: "#gradient-88"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-9",
    gradientUnits: "userSpaceOnUse",
    x1: 61.427,
    y1: 87.439,
    x2: 61.427,
    y2: 94.5,
    xlinkHref: "#gradient-88"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-10",
    gradientUnits: "userSpaceOnUse",
    x1: 55.562,
    y1: 102.5,
    x2: 55.562,
    y2: 126.5,
    xlinkHref: "#gradient-88"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-11",
    gradientUnits: "userSpaceOnUse",
    x1: 80.5,
    y1: 95.5,
    x2: 80.5,
    y2: 127.5,
    xlinkHref: "#gradient-88"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-12",
    gradientUnits: "userSpaceOnUse",
    x1: 81.35,
    y1: 46.476,
    x2: 81.35,
    y2: 145.546,
    xlinkHref: "#gradient-88"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-13",
    gradientUnits: "userSpaceOnUse",
    x1: 37,
    y1: 123.5,
    x2: 37,
    y2: 127.562,
    xlinkHref: "#gradient-88"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-14",
    gradientUnits: "userSpaceOnUse",
    x1: 71.498,
    y1: 115.5,
    x2: 71.498,
    y2: 150.565,
    xlinkHref: "#gradient-88"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-15",
    gradientUnits: "userSpaceOnUse",
    x1: 76.5,
    y1: 116.5,
    x2: 76.5,
    y2: 153.459,
    xlinkHref: "#gradient-88"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-16",
    gradientUnits: "userSpaceOnUse",
    x1: 92.207,
    y1: 25.375,
    x2: 92.207,
    y2: 169.423,
    xlinkHref: "#gradient-88"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-17",
    gradientUnits: "userSpaceOnUse",
    x1: 86.385,
    y1: 120.5,
    x2: 86.385,
    y2: 173.524,
    xlinkHref: "#gradient-88"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-18",
    gradientUnits: "userSpaceOnUse",
    x1: 123.5,
    y1: 119.745,
    x2: 123.5,
    y2: 161.5,
    xlinkHref: "#gradient-88"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-19",
    gradientUnits: "userSpaceOnUse",
    x1: 109.015,
    y1: 3.617,
    x2: 109.015,
    y2: 195.386,
    xlinkHref: "#gradient-88"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-20",
    gradientUnits: "userSpaceOnUse",
    x1: 152.266,
    y1: 59.5,
    x2: 152.266,
    y2: 182.5,
    xlinkHref: "#gradient-88"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-21",
    gradientUnits: "userSpaceOnUse",
    x1: 52.469,
    y1: 146.5,
    x2: 52.469,
    y2: 176.774,
    xlinkHref: "#gradient-88"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-88-22",
    gradientUnits: "userSpaceOnUse",
    x1: 93.5,
    y1: 161.5,
    x2: 93.5,
    y2: 167.5,
    xlinkHref: "#gradient-88"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.314,
      fill: "url(#gradient-88-0)"
    },
    d: "M 180.5,29.5 C 171.561,18.3587 160.227,10.692 146.5,6.5C 133.823,3.5145 121.156,2.84783 108.5,4.5C 104.295,4.71667 100.295,5.38333 96.5,6.5C 94.901,6.23219 93.5676,6.56552 92.5,7.5C 87.0828,8.19454 82.0828,9.8612 77.5,12.5C 65.5363,16.8087 54.8696,23.142 45.5,31.5C 41.9331,34.9774 38.5998,38.6441 35.5,42.5C 35.8333,41.1667 36.1667,39.8333 36.5,38.5C 51.5313,21.4753 70.1979,10.3086 92.5,5C 113.067,-0.264821 133.4,0.401846 153.5,7C 164.856,11.8711 173.856,19.3711 180.5,29.5 Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-88-1)"
    },
    d: "M 104.5,19.5 C 106.282,20.7196 108.282,21.3862 110.5,21.5C 110.5,21.8333 110.5,22.1667 110.5,22.5C 88.4149,24.5434 69.7482,33.5434 54.5,49.5C 57.4335,45.2272 60.7668,41.2272 64.5,37.5C 69.8414,34.1635 75.1748,30.8302 80.5,27.5C 88.1163,23.6923 96.1163,21.0257 104.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-88-2)"
    },
    d: "M 123.5,17.5 C 125.806,17.9926 128.139,18.3259 130.5,18.5C 133.461,19.3234 136.461,19.99 139.5,20.5C 147.671,23.4181 154.671,28.0848 160.5,34.5C 163.308,38.4496 165.308,42.783 166.5,47.5C 158.91,31.8437 146.244,23.3437 128.5,22C 122.509,21.5005 116.509,21.3338 110.5,21.5C 108.282,21.3862 106.282,20.7196 104.5,19.5C 106.265,18.5386 108.265,18.2053 110.5,18.5C 114.768,17.6274 119.102,17.2941 123.5,17.5 Z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-88-3)"
    },
    d: "M 110.5,22.5 C 110.5,22.1667 110.5,21.8333 110.5,21.5C 116.509,21.3338 122.509,21.5005 128.5,22C 146.244,23.3437 158.91,31.8437 166.5,47.5C 166.402,49.5529 167.069,51.2196 168.5,52.5C 168.738,60.8802 168.238,69.2135 167,77.5C 166.249,82.2109 164.749,86.5443 162.5,90.5C 164.628,83.6529 165.962,76.6529 166.5,69.5C 167.978,55.764 163.645,44.264 153.5,35C 141.879,27.8524 129.213,24.6858 115.5,25.5C 114.599,23.2729 112.933,22.2729 110.5,22.5 Z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-88-4)"
    },
    d: "M 110.5,22.5 C 112.933,22.2729 114.599,23.2729 115.5,25.5C 110.63,25.6896 105.964,26.3563 101.5,27.5C 97.521,27.7424 93.8544,28.7424 90.5,30.5C 88.847,30.6596 87.5137,31.3263 86.5,32.5C 82.4179,33.3764 78.7512,35.0431 75.5,37.5C 67.5925,41.6228 60.5925,46.9562 54.5,53.5C 50.7621,56.9103 47.7621,60.9103 45.5,65.5C 44.6618,65.1583 44.3284,64.4916 44.5,63.5C 45.7368,62.0351 46.7368,60.3684 47.5,58.5C 48.7787,55.8883 50.4453,53.5549 52.5,51.5C 52.8333,50.5 53.5,49.8333 54.5,49.5C 69.7482,33.5434 88.4149,24.5434 110.5,22.5 Z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-88-5)"
    },
    d: "M 112.5 39.5 C 112.833 39.5 113.167 39.5 113.5 39.5 C 116.5 39.5 119.5 39.5 122.5 39.5 C 125.903 39.851 129.237 40.518 132.5 41.5 C 138.057 43.064 142.057 46.397 144.5 51.5 C 147.324 57.081 148.657 63.081 148.5 69.5 C 147.626 72.535 146.626 75.535 145.5 78.5 C 148.903 57.559 139.903 46.893 118.5 46.5 C 111.405 46.279 104.738 47.613 98.5 50.5 C 96.182 50.993 94.182 51.993 92.5 53.5 C 88.345 54.742 84.678 56.742 81.5 59.5 C 81.167 59.5 80.833 59.5 80.5 59.5 C 75.421 63.037 70.754 67.037 66.5 71.5 C 65.167 72.167 64.167 73.167 63.5 74.5 C 61.833 75.5 60.5 76.833 59.5 78.5 C 57.14 80.713 55.306 83.379 54 86.5 C 53.601 86.272 53.435 85.938 53.5 85.5 C 53.893 83.716 54.559 82.05 55.5 80.5 C 56.58 78.004 57.914 75.671 59.5 73.5 C 60.5 72.167 61.5 70.833 62.5 69.5 C 64.167 67.5 65.833 65.5 67.5 63.5 C 68.167 63.167 68.833 62.833 69.5 62.5 C 72.194 59.14 75.194 56.14 78.5 53.5 C 80.833 52.167 83.167 50.833 85.5 49.5 C 89.849 46.659 94.516 44.326 99.5 42.5 C 103.767 41.302 108.1 40.302 112.5 39.5 Z M 124.445 42.495 C 124.44 42.494 124.436 42.494 124.431 42.493 C 111.237 41.232 98.927 43.9 87.5 50.5 C 98.931 43.898 111.246 41.23 124.445 42.495 Z M 5.5 88.5 C 10.252 98.55 18.252 103.55 29.5 103.5 C 34.5 103.5 39.5 103.5 44.5 103.5 C 51.297 102.789 57.964 101.456 64.5 99.5 C 67.5 98.167 70.5 96.833 73.5 95.5 C 75.565 95.483 77.565 95.15 79.5 94.5 C 94.326 93.918 108.492 90.585 122 84.5 C 122.149 87.196 120.982 89.196 118.5 90.5 C 117.167 92.167 115.833 93.833 114.5 95.5 C 111.907 96.754 109.573 98.42 107.5 100.5 C 104.527 102.147 101.86 104.147 99.5 106.5 C 96.55 107.308 93.883 108.642 91.5 110.5 C 71.791 120.678 51.124 123.511 29.5 119 C 24.714 116.38 20.714 112.88 17.5 108.5 C 15.823 106.46 14.156 104.46 12.5 102.5 C 8.6 98.7 6.266 94.033 5.5 88.5 Z M 64.5 99.5 C 67.415 100.122 70.415 100.456 73.5 100.5 C 70.415 100.456 67.415 100.122 64.5 99.5 Z M 73.5 100.5 C 88.773 99.299 103.44 95.632 117.5 89.5 C 103.44 95.632 88.773 99.299 73.5 100.5 Z M 117.5 89.5 C 118.107 89.624 118.44 89.957 118.5 90.5 C 118.44 89.957 118.107 89.624 117.5 89.5 Z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992,
      fill: "url(#gradient-88-6)"
    },
    d: "M 36.5 38.5 C 36.167 39.833 35.833 41.167 35.5 42.5 C 35.5 43.167 35.5 43.833 35.5 44.5 C 33.044 48.738 32.044 53.404 32.5 58.5 C 32.5 59.833 32.5 61.167 32.5 62.5 C 33.234 63.708 33.567 65.041 33.5 66.5 C 34.596 69.032 35.929 71.365 37.5 73.5 C 38.167 74.833 38.833 76.167 39.5 77.5 C 40.833 78.167 41.833 79.167 42.5 80.5 C 43.167 81.5 43.833 82.5 44.5 83.5 C 44.833 83.5 45.167 83.5 45.5 83.5 C 45.577 82.25 46.244 81.417 47.5 81 C 50.146 80.503 52.813 80.336 55.5 80.5 C 54.559 82.05 53.893 83.716 53.5 85.5 C 53.435 85.938 53.601 86.272 54 86.5 C 55.306 83.379 57.14 80.713 59.5 78.5 C 63.244 80.132 67.244 81.299 71.5 82 C 73.29 85.135 74.956 84.968 76.5 81.5 C 78.167 80.5 79.5 79.167 80.5 77.5 C 84.857 74.136 89.191 70.802 93.5 67.5 C 94.167 67.5 94.833 67.5 95.5 67.5 C 99.273 68.297 102.606 67.297 105.5 64.5 C 113.577 61.362 121.243 62.029 128.5 66.5 C 129.176 73.683 128.176 74.516 125.5 69 C 114.763 66.513 104.763 68.346 95.5 74.5 C 95.585 73.005 94.919 72.005 93.5 71.5 C 83.773 77.391 75.439 84.891 68.5 94 C 69.905 95.269 71.571 95.769 73.5 95.5 C 70.5 96.833 67.5 98.167 64.5 99.5 C 57.964 101.456 51.297 102.789 44.5 103.5 C 39.5 103.5 34.5 103.5 29.5 103.5 C 18.252 103.55 10.252 98.55 5.5 88.5 C 4.531 83.679 5.197 79.012 7.5 74.5 C 9.265 71.291 11.265 68.291 13.5 65.5 C 15.458 62.208 17.792 59.208 20.5 56.5 C 21.443 53.891 23.11 51.891 25.5 50.5 C 28.458 45.874 32.124 41.874 36.5 38.5 Z M 17.5 91 C 12.728 86.274 9.394 80.774 7.5 74.5 C 9.394 80.774 12.728 86.274 17.5 91 Z"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-88-7)"
    },
    d: "M 119.5,60.5 C 124.063,60.3326 127.063,62.3326 128.5,66.5C 121.243,62.0287 113.577,61.362 105.5,64.5C 104.227,63.9232 104.227,63.2565 105.5,62.5C 109.997,60.7829 114.663,60.1162 119.5,60.5 Z"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-88-8)"
    },
    d: "M 95.5,74.5 C 91.5155,76.4955 87.8488,78.9955 84.5,82C 87.6117,83.5992 89.2784,86.0992 89.5,89.5C 88.2905,89.9321 87.2905,90.5987 86.5,91.5C 83.9823,92.2638 81.649,93.2638 79.5,94.5C 77.5648,95.1495 75.5648,95.4828 73.5,95.5C 71.5714,95.7692 69.9047,95.2692 68.5,94C 75.4393,84.8911 83.7726,77.3911 93.5,71.5C 94.9185,72.0047 95.5852,73.0047 95.5,74.5 Z"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-88-9)"
    },
    d: "M 56.5,87.5 C 59.1873,87.3359 61.854,87.5026 64.5,88C 69.4673,90.0395 69.6339,92.2061 65,94.5C 61.2505,93.3084 57.7505,91.6418 54.5,89.5C 55.2427,88.8182 55.9094,88.1515 56.5,87.5 Z"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-88-10)"
    },
    d: "M 99.5 106.5 C 85.551 116.931 69.884 123.264 52.5 125.5 C 49.5 125.5 46.5 125.5 43.5 125.5 C 42.036 126.16 40.369 126.493 38.5 126.5 C 32.718 126.037 27.052 125.037 21.5 123.5 C 19.833 122.833 18.167 122.167 16.5 121.5 C 11.871 115.971 10.538 109.638 12.5 102.5 C 14.156 104.46 15.823 106.46 17.5 108.5 C 20.714 112.88 24.714 116.38 29.5 119 C 51.124 123.511 71.791 120.678 91.5 110.5 C 93.883 108.642 96.55 107.308 99.5 106.5 Z M 43.5 125.5 C 31.003 126.426 22.003 121.426 16.5 110.5 C 22.003 121.426 31.003 126.426 43.5 125.5 Z"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-88-11)"
    },
    d: "M 114.5,95.5 C 113.167,97.1667 111.833,98.8333 110.5,100.5C 106.518,103.152 102.851,106.152 99.5,109.5C 96.331,110.917 93.331,112.583 90.5,114.5C 76.8704,122.242 62.2038,126.575 46.5,127.5C 48.5,126.833 50.5,126.167 52.5,125.5C 69.884,123.264 85.5506,116.931 99.5,106.5C 101.86,104.147 104.527,102.147 107.5,100.5C 109.573,98.4202 111.907,96.7536 114.5,95.5 Z"
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-88-12)"
    },
    d: "M 41.5 145 C 37.951 144.226 34.618 142.893 31.5 141 C 27.559 137.562 24.225 133.729 21.5 129.5 C 21.25 127.326 20.25 125.659 18.5 124.5 C 17.599 123.71 16.932 122.71 16.5 121.5 C 18.167 122.167 19.833 122.833 21.5 123.5 C 24.135 125.328 27.135 126.495 30.5 127 C 35.823 127.499 41.156 127.666 46.5 127.5 C 62.204 126.575 76.87 122.242 90.5 114.5 C 93.331 112.583 96.331 110.917 99.5 109.5 C 102.851 106.152 106.518 103.152 110.5 100.5 C 111.833 98.833 113.167 97.167 114.5 95.5 C 115.833 93.833 117.167 92.167 118.5 90.5 C 120.982 89.196 122.149 87.196 122 84.5 C 108.492 90.585 94.326 93.918 79.5 94.5 C 81.649 93.264 83.982 92.264 86.5 91.5 C 87.291 90.599 88.291 89.932 89.5 89.5 C 89.278 86.099 87.612 83.599 84.5 82 C 87.849 78.996 91.516 76.496 95.5 74.5 C 104.763 68.347 114.763 66.513 125.5 69 C 128.176 74.516 129.176 73.683 128.5 66.5 C 127.063 62.333 124.063 60.333 119.5 60.5 C 114.663 60.116 109.997 60.783 105.5 62.5 C 104.227 63.257 104.227 63.923 105.5 64.5 C 102.606 67.297 99.273 68.297 95.5 67.5 C 94.833 67.5 94.167 67.5 93.5 67.5 C 89.191 70.802 84.857 74.136 80.5 77.5 C 79.5 79.167 78.167 80.5 76.5 81.5 C 74.956 84.968 73.29 85.135 71.5 82 C 67.244 81.299 63.244 80.132 59.5 78.5 C 60.5 76.833 61.833 75.5 63.5 74.5 C 64.167 73.167 65.167 72.167 66.5 71.5 C 70.754 67.037 75.421 63.037 80.5 59.5 C 80.833 59.5 81.167 59.5 81.5 59.5 C 84.678 56.742 88.345 54.742 92.5 53.5 C 94.182 51.993 96.182 50.993 98.5 50.5 C 104.738 47.613 111.405 46.279 118.5 46.5 C 139.903 46.893 148.903 57.559 145.5 78.5 C 145.167 82.5 144.833 82.5 144.5 78.5 C 138.858 76.713 133.358 75.379 128 74.5 C 117.489 78.831 106.989 82.831 96.5 86.5 C 106.596 84.913 116.263 81.913 125.5 77.5 C 126.192 78.025 126.692 78.692 127 79.5 C 132.353 78.942 137.353 80.275 142 83.5 C 142.667 85.167 142.667 86.833 142 88.5 C 140.236 90.389 138.736 92.389 137.5 94.5 C 135.6 98.732 132.933 102.399 129.5 105.5 C 127.213 109.122 124.547 112.455 121.5 115.5 C 121.167 115.5 120.833 115.5 120.5 115.5 C 115.781 119.553 110.781 123.22 105.5 126.5 C 101.37 129.403 97.037 132.07 92.5 134.5 C 76.654 143.502 59.654 147.002 41.5 145 Z"
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-88-13)"
    },
    d: "M 21.5,123.5 C 27.0517,125.037 32.7183,126.037 38.5,126.5C 40.3693,126.493 42.036,126.16 43.5,125.5C 46.5,125.5 49.5,125.5 52.5,125.5C 50.5,126.167 48.5,126.833 46.5,127.5C 41.1563,127.666 35.8229,127.499 30.5,127C 27.135,126.495 24.135,125.328 21.5,123.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-88-14)"
    },
    d: "M 120.5,115.5 C 120.833,115.5 121.167,115.5 121.5,115.5C 121.5,115.833 121.5,116.167 121.5,116.5C 105.702,131.564 87.3691,142.231 66.5,148.5C 63.0611,148.788 59.7278,149.454 56.5,150.5C 50.1021,150.757 43.7688,150.257 37.5,149C 33.1417,147.828 29.475,145.661 26.5,142.5C 23.0744,138.897 21.4077,134.563 21.5,129.5C 24.2254,133.729 27.5587,137.562 31.5,141C 34.618,142.893 37.9513,144.226 41.5,145C 59.6539,147.002 76.6539,143.502 92.5,134.5C 97.0366,132.07 101.37,129.403 105.5,126.5C 110.781,123.22 115.781,119.553 120.5,115.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-88-15)"
    },
    d: "M 121.5 116.5 C 121.833 116.5 122.167 116.5 122.5 116.5 C 122.167 117.167 121.833 117.833 121.5 118.5 C 118.808 120.862 116.141 123.196 113.5 125.5 C 98.993 137.254 82.66 145.588 64.5 150.5 C 53.199 154.605 41.865 154.438 30.5 150 C 31 149.833 31.5 149.667 32 149.5 C 40.227 152.698 48.394 153.031 56.5 150.5 C 59.728 149.454 63.061 148.788 66.5 148.5 C 87.369 142.231 105.702 131.564 121.5 116.5 Z M 64.5 150.5 C 64.062 150.565 63.728 150.399 63.5 150 C 63.728 150.399 64.062 150.565 64.5 150.5 Z M 63.5 150 C 64.738 149.768 65.738 149.268 66.5 148.5 C 65.738 149.268 64.738 149.768 63.5 150 Z"
  })), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-88-16)"
    },
    d: "M 72.5 168 C 63.139 169.898 53.805 169.898 44.5 168 C 36.761 165.094 31.094 159.927 27.5 152.5 C 26.28 150.019 24.614 148.019 22.5 146.5 C 21.833 145.167 21.167 143.833 20.5 142.5 C 17.535 136.779 16.869 130.779 18.5 124.5 C 20.25 125.659 21.25 127.326 21.5 129.5 C 21.408 134.563 23.074 138.897 26.5 142.5 C 29.475 145.661 33.142 147.828 37.5 149 C 43.769 150.257 50.102 150.757 56.5 150.5 C 48.394 153.031 40.227 152.698 32 149.5 C 31.5 149.667 31 149.833 30.5 150 C 41.865 154.438 53.199 154.605 64.5 150.5 C 82.66 145.588 98.993 137.254 113.5 125.5 C 116.141 123.196 118.808 120.862 121.5 118.5 C 121.833 117.833 122.167 117.167 122.5 116.5 C 122.167 116.5 121.833 116.5 121.5 116.5 C 121.5 116.167 121.5 115.833 121.5 115.5 C 124.547 112.455 127.213 109.122 129.5 105.5 C 132.933 102.399 135.6 98.732 137.5 94.5 C 138.736 92.389 140.236 90.389 142 88.5 C 142.667 86.833 142.667 85.167 142 83.5 C 137.353 80.275 132.353 78.942 127 79.5 C 126.692 78.692 126.192 78.025 125.5 77.5 C 116.263 81.913 106.596 84.913 96.5 86.5 C 106.989 82.831 117.489 78.831 128 74.5 C 133.358 75.379 138.858 76.713 144.5 78.5 C 144.833 82.5 145.167 82.5 145.5 78.5 C 146.626 75.535 147.626 72.535 148.5 69.5 C 148.657 63.081 147.324 57.081 144.5 51.5 C 142.057 46.397 138.057 43.064 132.5 41.5 C 129.237 40.518 125.903 39.851 122.5 39.5 C 119.5 39.5 116.5 39.5 113.5 39.5 C 113.167 39.5 112.833 39.5 112.5 39.5 C 108.1 40.302 103.767 41.302 99.5 42.5 C 94.516 44.325 89.849 46.659 85.5 49.5 C 83.167 50.833 80.833 52.167 78.5 53.5 C 75.194 56.139 72.194 59.139 69.5 62.5 C 68.833 62.833 68.167 63.167 67.5 63.5 C 65.833 65.5 64.167 67.5 62.5 69.5 C 61.5 70.833 60.5 72.167 59.5 73.5 C 54.538 73.255 49.705 73.922 45 75.5 C 43.97 75.164 43.47 74.497 43.5 73.5 C 43.171 70.772 43.837 68.439 45.5 66.5 C 45.5 66.167 45.5 65.833 45.5 65.5 C 47.762 60.91 50.762 56.91 54.5 53.5 C 60.593 46.956 67.593 41.623 75.5 37.5 C 78.751 35.043 82.418 33.376 86.5 32.5 C 87.514 31.326 88.847 30.66 90.5 30.5 C 93.854 28.742 97.521 27.742 101.5 27.5 C 105.964 26.356 110.63 25.69 115.5 25.5 C 129.213 24.686 141.879 27.852 153.5 35 C 163.645 44.264 167.978 55.764 166.5 69.5 C 165.962 76.653 164.628 83.653 162.5 90.5 C 162.167 90.5 161.833 90.5 161.5 90.5 C 161.293 93.241 160.293 95.574 158.5 97.5 C 157.258 101.655 155.258 105.322 152.5 108.5 C 150.167 112.5 147.833 116.5 145.5 120.5 C 145.167 120.5 144.833 120.5 144.5 120.5 C 142.157 123.207 139.823 125.874 137.5 128.5 C 119.543 147.595 97.876 160.761 72.5 168 Z"
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-88-17)"
    },
    d: "M 144.5,120.5 C 144.833,120.5 145.167,120.5 145.5,120.5C 139.806,128.704 133.14,136.204 125.5,143C 116.942,149.434 108.276,155.601 99.5,161.5C 95.1822,162.992 91.1822,164.992 87.5,167.5C 86.2196,168.931 84.5529,169.598 82.5,169.5C 72.381,172.39 62.0477,173.723 51.5,173.5C 43.1797,173.505 36.1797,170.505 30.5,164.5C 27.7715,160.701 26.7715,156.701 27.5,152.5C 31.0942,159.927 36.7609,165.094 44.5,168C 53.8052,169.898 63.1385,169.898 72.5,168C 97.8759,160.761 119.543,147.595 137.5,128.5C 139.823,125.874 142.157,123.207 144.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-88-18)"
    },
    d: "M 147.5,120.5 C 146.89,121.391 146.557,122.391 146.5,123.5C 143.195,127.141 139.862,130.808 136.5,134.5C 133.833,136.5 131.5,138.833 129.5,141.5C 120.298,149.369 110.298,156.036 99.5,161.5C 108.276,155.601 116.942,149.434 125.5,143C 133.14,136.204 139.806,128.704 145.5,120.5C 146.396,119.494 147.062,119.494 147.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.989,
      fill: "url(#gradient-88-19)"
    },
    d: "M 150.5 148.5 C 147.862 151.474 145.195 154.474 142.5 157.5 C 132.382 166.628 121.715 174.961 110.5 182.5 C 93.956 192.578 75.956 196.745 56.5 195 C 48.205 194.27 41.372 190.77 36 184.5 C 32.302 179.102 29.135 173.435 26.5 167.5 C 34.233 174.745 43.233 177.745 53.5 176.5 C 63.781 176.314 73.448 173.981 82.5 169.5 C 84.553 169.598 86.22 168.931 87.5 167.5 C 92.086 166.54 96.086 164.54 99.5 161.5 C 110.298 156.036 120.298 149.369 129.5 141.5 C 131.5 138.833 133.833 136.5 136.5 134.5 C 139.862 130.808 143.195 127.141 146.5 123.5 C 146.557 122.391 146.89 121.391 147.5 120.5 C 147.062 119.494 146.396 119.494 145.5 120.5 C 147.833 116.5 150.167 112.5 152.5 108.5 C 155.258 105.322 157.258 101.655 158.5 97.5 C 160.293 95.574 161.293 93.241 161.5 90.5 C 161.833 90.5 162.167 90.5 162.5 90.5 C 164.749 86.544 166.249 82.211 167 77.5 C 168.238 69.214 168.738 60.88 168.5 52.5 C 167.069 51.22 166.402 49.553 166.5 47.5 C 165.308 42.783 163.308 38.45 160.5 34.5 C 154.671 28.085 147.671 23.418 139.5 20.5 C 136.461 19.99 133.461 19.323 130.5 18.5 C 128.139 18.326 125.806 17.993 123.5 17.5 C 119.102 17.294 114.768 17.627 110.5 18.5 C 108.265 18.205 106.265 18.539 104.5 19.5 C 96.116 21.026 88.116 23.692 80.5 27.5 C 75.175 30.83 69.841 34.164 64.5 37.5 C 60.767 41.227 57.433 45.227 54.5 49.5 C 53.5 49.833 52.833 50.5 52.5 51.5 C 50.445 53.555 48.779 55.888 47.5 58.5 C 46.737 60.368 45.737 62.035 44.5 63.5 C 44.328 64.492 44.662 65.158 45.5 65.5 C 45.5 65.833 45.5 66.167 45.5 66.5 C 43.837 68.439 43.171 70.772 43.5 73.5 C 43.47 74.497 43.97 75.164 45 75.5 C 49.705 73.922 54.538 73.255 59.5 73.5 C 57.914 75.671 56.58 78.004 55.5 80.5 C 52.813 80.336 50.146 80.503 47.5 81 C 46.244 81.417 45.577 82.25 45.5 83.5 C 45.167 83.5 44.833 83.5 44.5 83.5 C 43.833 82.5 43.167 81.5 42.5 80.5 C 41.833 79.167 40.833 78.167 39.5 77.5 C 38.833 76.167 38.167 74.833 37.5 73.5 C 35.929 71.365 34.596 69.032 33.5 66.5 C 33.567 65.041 33.234 63.708 32.5 62.5 C 32.5 61.167 32.5 59.833 32.5 58.5 C 32.044 53.405 33.044 48.738 35.5 44.5 C 35.5 43.833 35.5 43.167 35.5 42.5 C 38.6 38.644 41.933 34.977 45.5 31.5 C 54.87 23.142 65.536 16.809 77.5 12.5 C 82.083 9.861 87.083 8.195 92.5 7.5 C 93.568 6.566 94.901 6.232 96.5 6.5 C 100.295 5.383 104.295 4.717 108.5 4.5 C 121.156 2.848 133.823 3.515 146.5 6.5 C 160.227 10.692 171.561 18.359 180.5 29.5 C 186.91 38.386 190.576 48.386 191.5 59.5 C 191.753 69.731 190.419 79.731 187.5 89.5 C 187.167 90.167 186.833 90.833 186.5 91.5 C 185.499 94.172 184.499 96.838 183.5 99.5 C 183.34 101.153 182.674 102.486 181.5 103.5 C 181.008 105.819 180.008 107.819 178.5 109.5 C 177.331 112.511 175.664 115.178 173.5 117.5 C 173.167 118.833 172.833 120.167 172.5 121.5 C 171.167 122.833 169.833 124.167 168.5 125.5 C 166.833 128.167 165.167 130.833 163.5 133.5 C 162.167 134.833 160.833 136.167 159.5 137.5 C 158.2 140.432 156.2 142.766 153.5 144.5 C 152.5 145.833 151.5 147.167 150.5 148.5 Z M 147.5 120.5 C 149.063 119.055 150.396 117.389 151.5 115.5 C 150.396 117.389 149.063 119.055 147.5 120.5 Z M 151.5 115.5 C 153.167 112.833 154.833 110.167 156.5 107.5 C 154.833 110.167 153.167 112.833 151.5 115.5 Z M 157.5 104.5 C 160.283 99.77 162.95 94.936 165.5 90 C 162.95 94.936 160.283 99.77 157.5 104.5 Z M 165.5 90 C 172.512 90.046 179.512 90.546 186.5 91.5 C 179.512 90.546 172.512 90.046 165.5 90 Z M 166.5 87.5 C 167.01 82.789 167.844 78.122 169 73.5 C 167.844 78.122 167.01 82.789 166.5 87.5 Z M 169 73.5 C 169.821 66.321 169.655 59.321 168.5 52.5 C 169.655 59.321 169.821 66.321 169 73.5 Z"
  })), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.939,
      fill: "url(#gradient-88-20)"
    },
    d: "M 124.5 176 C 119.932 178.452 115.265 180.618 110.5 182.5 C 121.715 174.961 132.382 166.628 142.5 157.5 C 145.195 154.474 147.862 151.474 150.5 148.5 C 151.5 147.167 152.5 145.833 153.5 144.5 C 156.2 142.766 158.2 140.432 159.5 137.5 C 160.833 136.167 162.167 134.833 163.5 133.5 C 165.167 130.833 166.833 128.167 168.5 125.5 C 169.833 124.167 171.167 122.833 172.5 121.5 C 172.833 120.167 173.167 118.833 173.5 117.5 C 175.664 115.178 177.331 112.511 178.5 109.5 C 180.008 107.819 181.008 105.819 181.5 103.5 C 182.674 102.486 183.34 101.153 183.5 99.5 C 184.499 96.838 185.499 94.172 186.5 91.5 C 186.833 90.833 187.167 90.167 187.5 89.5 C 190.419 79.731 191.753 69.731 191.5 59.5 C 193.963 69.623 194.63 79.956 193.5 90.5 C 192.905 97.219 191.238 103.552 188.5 109.5 C 187.892 112.327 186.892 114.993 185.5 117.5 C 183.167 121.5 180.833 125.5 178.5 129.5 C 174.539 135.759 169.873 141.425 164.5 146.5 C 153.192 158.997 139.859 168.83 124.5 176 Z M 183.5 99.5 C 187.462 97.205 190.795 94.205 193.5 90.5 C 190.795 94.205 187.462 97.205 183.5 99.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-88-21)"
    },
    d: "M 22.5 146.5 C 24.614 148.019 26.28 150.019 27.5 152.5 C 26.772 156.701 27.772 160.701 30.5 164.5 C 36.18 170.505 43.18 173.505 51.5 173.5 C 62.048 173.723 72.381 172.39 82.5 169.5 C 73.448 173.981 63.781 176.314 53.5 176.5 C 43.233 177.745 34.233 174.745 26.5 167.5 C 25.326 166.486 24.66 165.153 24.5 163.5 C 23.732 162.737 23.232 161.737 23 160.5 C 22.501 155.845 22.334 151.179 22.5 146.5 Z M 51.5 173.5 C 53.969 174.317 56.635 174.817 59.5 175 C 56.635 174.817 53.969 174.317 51.5 173.5 Z M 59.5 175 C 57.292 175.191 55.292 175.691 53.5 176.5 C 55.292 175.691 57.292 175.191 59.5 175 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-88-22)"
    },
    d: "M 99.5,161.5 C 96.0864,164.54 92.0864,166.54 87.5,167.5C 91.1822,164.992 95.1822,162.992 99.5,161.5 Z"
  })), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478.454041, 127.90197)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForge);
export default __webpack_public_path__ + "static/media/forge.9fee69b6e6de752f8ea27f7cacc75165.svg";
export { ForwardRef as ReactComponent };